import type { AssetTypeDetail } from "./asset-type.type";
import type { UseGetOptions } from "@/hooks/queries";

import { useGet } from "@/hooks/queries";

export const useGetAssetType = (
  assetTypeId?: string | number,
  options?: UseGetOptions<AssetTypeDetail>
) => {
  const { data, ...queryResult } = useGet<AssetTypeDetail>(
    "assetTypes",
    assetTypeId,
    options
  );

  return {
    assetType: data,
    ...queryResult,
  };
};
